module.exports = __webpack_public_path__ + "static/media/connected_faith.d5951363.png";